// '发起申请'弹窗所有按钮
let TaskListInfo = {
    todo: {
        api: '/sp/v1/process/daiban',
        name: '待处理任务',
        nameSimple: '待处理',
        data: {}
    },
    mine: {
        api: '/sp/v1/process/me',
        name: '我的申请',
        nameSimple: '我的申请',
        data: {}
    },
    tome: {
        api: '/sp/v1/process/cs',
        name: '抄送给我的申请',
        nameSimple: '抄送给我',
        data: {}
    },
    record: {
        api: '/sp/v1/process/record',
        name: '审批记录',
        nameSimple: '审批记录',
        data: {}
    },
    search: {
        name: '搜索结果',
        nameSimple: '搜索结果',
        data: {},
        tempApi: '/sp/v1/process/search'
    }
}
export default TaskListInfo;
